import React from 'react'
import Text from '../../shared/textStyleDefault/texto'

const CookiesTable: React.FC = () => (
  <div className="mt-24">
    <div className="flex items-center text-xl font-semibold mb-4">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <path d="M8 9.5H4V20.5H8V9.5Z" fill="#030712"/>
  <path d="M20 13.5H16V20.5H20V13.5Z" fill="#030712"/>
  <path d="M14 4.5H10V20.5H14V4.5Z" fill="#030712"/>
</svg>
      <Text as="h4" className='ml-3'>Datos de las Cookies</Text>

    </div>
    <div>
    <Text as="h5" className='mt-14 mb-12'>A continuación, te mostramos información detallada sobre las cookies utilizadas en nuestro sitio web:</Text>

    </div>
    <div className="overflow-x-auto">
    <table className='table table-striped table-bordered table-responsive'>
          <thead>
            <tr>
              <th scope='col'> { ('cookie-nombre') } </th>
              <th scope='col'> { ('cookie-proveedor') } </th>
              <th scope='col'> { ('cookie-categoria') } </th>
              <th scope='col'> { ('cookie-funcion') } </th>
              <th scope='col'> { ('cookie-caducidad') } </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope='row'> _ga </th>
              <td> Google LLC </td>
              <td> ANALYTICS </td>
              <td> Distingue visitantes para contar su número</td>
              <td> 2 años</td>
            </tr>
          </tbody>
        </table>
    </div>
  </div>
)

export default CookiesTable
